'use client';

import { motion } from 'framer-motion';
import { TextGenerateEffect } from '../../../components/text-generate-effect';
import { MapPin } from 'lucide-react';

export default function HeroSection(): JSX.Element {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.4, ease: 'easeOut' }}
			className="w-full text-center space-y-3 sm:space-y-4 md:space-y-6"
		>
			<div className="font-bold cosmic-text font-space-grotesk space-y-2 sm:space-y-4">
				<TextGenerateEffect
					words="Empower Your Business With"
					secondLineWords="Tailored Tech Solutions"
					className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl"
					secondLineClassName="text-orange-500"
					duration={0.6}
				/>
			</div>
			<p className="text-sm sm:text-base md:text-lg lg:text-xl text-muted-foreground max-w-2xl mx-auto px-4 sm:px-6">
				We specialize in helping solo entrepreneurs and small businesses thrive in the digital age.
				From personalized consulting to custom development, we create solutions that fit your unique
				needs and budget.
			</p>
			<div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-muted-foreground/80 px-4 sm:px-0">
				<MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-orange-500" />
				<p className="text-sm sm:text-base text-center sm:text-left">
					Serving SMBs in Alhambra, Monterey Park, Pasadena, Altadena, San Gabriel, and San Marino
				</p>
			</div>
		</motion.div>
	);
}
